export { default } from "truth-helpers/helpers/eq";
